<template>
    <div class="h-75 flex-grow-1 d-flex flex-column">
        <vue-keypress key-event="keydown" :key-code="78" :modifiers="['altKey']" :preventDefault="true" @success="createEntry"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="82" :modifiers="['altKey']" :preventDefault="true" @success="refreshGlossary"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="67" :modifiers="['altKey']" :preventDefault="true" @success="copyGlossaryBtn"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="80" :modifiers="['altKey']" :preventDefault="true" @success="printGlossary"></vue-keypress>
        <b-row id="toolbar">
            <b-col cols="auto">
                <b-input-group ref="searchControls">
                    <vue-keypress key-event="keydown" :key-code="13" @success="handleEnterKey"></vue-keypress>
                    <b-form-input name="searchTerm" v-model="searchTerm" />
                    <b-button v-on:click="searchGlossary" class="btn btn-outline-secondary btn-sm ml-2" variant="outline-secondary"><i class="fas fa-search whiteiconcolor"></i></b-button>
                    <b-button v-on:click="clearSearch" class="btn btn-outline-secondary btn-sm ml-2" variant="outline-secondary"><i class="fas fa-times whiteiconcolor"></i></b-button>
                </b-input-group>
            </b-col>
            <b-col cols="auto">
                <b-button v-on:click="createEntry" class="btn btn-outline-secondary ml-3" variant="outline-secondary" data-toggle="tooltip" title="Alt + N">
                    <i class="fas fa-plus mr-1"></i><u>N</u>ew Entry
                </b-button>
            </b-col>
            <b-col cols="auto">
                <b-button v-on:click="refreshGlossary" class="btn btn-outline-secondary ml-1" variant="outline-secondary" data-toggle="tooltip" title="Alt + R">
                    <i class="fas fa-sync-alt mr-1"></i><u>R</u>efresh
                </b-button>
            </b-col>
            <b-col cols="auto">
                <b-button v-on:click="copyGlossaryBtn" class="btn btn-outline-secondary ml-1" variant="outline-secondary" data-toggle="tooltip" title="Alt + C">
                    <i class="fas fa-copy mr-1"></i><u>C</u>opy To
                </b-button>
            </b-col>
            <b-col cols="auto">
                <b-button v-on:click="printGlossary" class="btn btn-outline-secondary ml-1" variant="outline-secondary" data-toggle="tooltip" title="Alt + P">
                    <i class="fas fa-print mr-1"></i><u>P</u>rint PDF
                </b-button>
            </b-col>

            <b-col>
                &nbsp;
            </b-col>

            <b-col cols="auto" class="mt-0">
                <b-button v-if="sortByWordOrTerm" v-on:click="toggleSortByWordOrTerm" class="btn btn-secondary ml-1" variant="secondary" data-toggle="tooltip" title="Display the glossary sorted by the word, term or phrase">
                    <i class="fas fa-sort-alpha-down whiteiconcolor"></i>
                </b-button>
                <b-button v-if="sortByWordOrTerm" v-on:click="toggleSortByCategory" class="btn btn-outline-secondary ml-1" variant="outline-secondary" data-toggle="tooltip" title="Display the glossary sorted by the entry category">
                    <i class="fas fa-sort-amount-down"></i>
                </b-button>

                <b-button v-if="!sortByWordOrTerm" v-on:click="toggleSortByWordOrTerm" class="btn btn-outline-secondary ml-1" variant="outline-secondary" data-toggle="tooltip" title="Display the glossary sorted by the word, term or phrase">
                    <i class="fas fa-sort-alpha-down"></i>
                </b-button>
                <b-button v-if="!sortByWordOrTerm" v-on:click="toggleSortByCategory" class="btn btn-secondary ml-1" variant="secondary" data-toggle="tooltip" title="Display the glossary sorted by the entry category">
                    <i class="fas fa-sort-amount-down whiteiconcolor"></i>
                </b-button>
                <b-button v-if="!showCards" v-on:click="toggleLines" class="btn btn-secondary ml-3" variant="secondary" data-toggle="tooltip" title="Display the entries in single lines">
                    <i class="fas fa-grip-lines whiteiconcolor"></i>
                </b-button>
                <b-button v-if="!showCards" v-on:click="toggleCards" class="btn btn-outline-secondary ml-1" variant="outline-secondary" data-toggle="tooltip" title="Display the entries in multiple columns">
                    <i class="fas fa-grip-vertical"></i>
                </b-button>

                <b-button v-if="showCards" v-on:click="toggleLines" class="btn btn-outline-secondary ml-1" variant="outline-secondary" data-toggle="tooltip" title="Display the entries in single lines">
                    <i class="fas fa-grip-lines"></i>
                </b-button>
                <b-button v-if="showCards" v-on:click="toggleCards" class="btn btn-secondary ml-1" variant="secondary" data-toggle="tooltip" title="Display the entries in multiple columns">
                    <i class="fas fa-grip-vertical whiteiconcolor"></i>
                </b-button>

                <div class="btn-group ml-1" v-if="showCards">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Cols
                    </button>
                    <div class="dropdown-menu">
                        <a v-bind:class="displayColumns == 2 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(2)">2</a>
                        <a v-bind:class="displayColumns == 3 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(3)">3</a>
                        <a v-bind:class="displayColumns == 4 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(4)">4</a>
                        <a v-bind:class="displayColumns == 5 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(5)">5</a>
                        <a v-bind:class="displayColumns == 6 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(6)">6</a>
                        <a v-bind:class="displayColumns == 7 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(7)">7</a>
                        <a v-bind:class="displayColumns == 8 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(8)">8</a>
                        <a v-bind:class="displayColumns == 9 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(9)">9</a>
                        <a v-bind:class="displayColumns == 10 ? 'dropdown-item active' : 'dropdown-item'" v-on:click="setColumns(10)">10</a>
                    </div>
                </div>
            </b-col>

            <b-col cols="auto" class="mt-0">
                <b-form-checkbox switch v-model="showDeleted" v-on:change="toggleDeleted">Show Deleted</b-form-checkbox>
                <b-form-checkbox switch v-model="showDescription" v-on:change="toggleDescription" class="mt-1">Show Descriptions</b-form-checkbox>
            </b-col>
            <b-col cols="auto" class="mt-2">
                ({{ entryCount }} Records)
            </b-col>
        </b-row>

        <b-row class="mt-2" id="categoryNavbar">
            <b-col>&nbsp;</b-col>
            <b-col v-if="sortByWordOrTerm" cols="auto">
                <b-badge v-on:click="filterByCategoryNameAndId(null,null)"
                         href="#"
                         class="mr-2"
                         :variant="selectedCategoryColor(null)"
                         active-class="danger">
                    All Categories
                </b-badge>
                <b-badge v-for="(category,index) in headers.glossaryEntryCategories"
                         href="#"
                         v-on:click="filterByCategoryNameAndId(category.name,category.glossaryEntryCategoryId)"
                         :key="index"
                         class="mr-2"
                         :variant="selectedCategoryColor(category.glossaryEntryCategoryId)"
                         active-class="danger">
                    {{ category.name }}
                </b-badge>
            </b-col>
            <b-col v-if="!sortByWordOrTerm" cols="auto">
                <b-badge v-on:click="filterByCategoryNameAndId(null,null)"
                         href="#"
                         class="mr-2"
                         :variant="selectedCategoryColor(null)"
                         active-class="danger">
                    All Categories
                </b-badge>
                <b-badge v-for="(category,index) in headers.glossaryEntryCategoryHeaderList"
                         href="#"
                         v-on:click="filterByCategoryNameAndId(category.glossaryEntryCategory.name,category.glossaryEntryCategory.glossaryEntryCategoryId)"
                         :key="index"
                         class="mr-2"
                         :variant="selectedCategoryColor(category.glossaryEntryCategory.glossaryEntryCategoryId)"
                         active-class="danger">
                    {{ category.glossaryEntryCategory.name }}
                </b-badge>
            </b-col>
            <b-col>&nbsp;</b-col>
        </b-row>

        <!--<b-row class="mt-3" id="letterNavbar">
            <b-col>&nbsp;</b-col>
            <b-col cols="auto" v-if="sortByWordOrTerm">
                <b-list-group horizontal v-b-scrollspy:nav-scroller>
                    <b-list-group-item v-for="(char,index) in headers.headerLetters" :key="index" :href="'#' + char">{{ char }}</b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col cols="auto" v-if="!sortByWordOrTerm">
                <b-list-group horizontal v-b-scrollspy:nav-scroller>
                    <b-list-group-item v-for="(category,index) in headers.glossaryEntryCategoryHeaderList"
                                       :key="index"
                                       :href="'#' + category.glossaryEntryCategory.name">{{ category.glossaryEntryCategory.name }}</b-list-group-item>
                </b-list-group>
            </b-col>
            <b-col>&nbsp;</b-col>
        </b-row>-->

        <b-row id="printHeader">
            <h3 class="mb-2">Electronic Glossary - {{ courtMatterOrInterviewName }}</h3>
        </b-row>

        <b-row id="printHeader">
            <h5>Data current as at {{ formatDateTime(now(), 'DD/MM/YYYY h:mmA', false, false) }}</h5>
        </b-row>

        <b-row id="printHeader">
            <h5 v-if="showDeleted">Deleted Items Shown</h5>
        </b-row>

        <!--<div>
            <span class="text-success"><i class="fas fa-check"></i></span>&nbsp;= Confirmed&nbsp;&nbsp;&nbsp;
            <span class="text-danger"><i class="fas fa-check"></i></span>&nbsp;= Not Confirmed
        </div>-->

        <div v-if="sortByWordOrTerm">
            <b-row class="mt-2" id="headerRow">
                <b-col :cols="sortByWordOrTerm ? 1 : 2"></b-col>
                <b-col :cols="sortByWordOrTerm ? 11 : 10">
                    <b-row>
                        <b-col cols="4"><h5>Word, Term or Phrase</h5></b-col>
                        <b-col cols="8" v-if="showDescription"><h5>Description</h5></b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>

        <div class="glossary-grid-container">
            <!-- Glossary Content Div  -->
            <div class="mt-2" style="grid-area: pinnedHead;">
                <b-row>
                    <b-col cols="12" class="d-flex justify-content-between" style="padding-right:0">
                        <div class="badge-info ml-0 flex-fill">
                            <strong class="ml-2">Pinned Entries ({{ pinnedItemCount() }})</strong>
                        </div>
                        <div class="badge-info ml-0" style="padding-right:15px">
                            <b-button v-on:click="hidePinnedSection" size="sm" style="max-height:100%">Collapse</b-button>
                            <b-button v-on:click="resetPinnedSectionHeight" size="sm" style="max-height:100%">Reset Height</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div id="sticky" class="mt-0 border">
                <b-row>
                    <b-col :cols="sortByWordOrTerm ? 1 : 2"></b-col>
                    <b-col v-if="!showCards" :cols="sortByWordOrTerm ? 11 : 10">
                        <b-row v-for="(entry,index) in filterGlossaryByPinned()"
                               :key="index"
                               :class="entry.rowClass"
                               :data-glossary-entry-id="entry.glossaryEntryId">
                            <b-col cols="4" v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'">
                                <span>&nbsp;<i class="fas fa-map-pin"></i>&nbsp;&nbsp;</span>
                                <!--<span v-bind:class="entry.confirmedDateTimeUTC == null ? 'text-danger' : 'text-success'"><i class="fas fa-check"></i></span>&nbsp;<strong>{{ entry.wordTermOrPhrase }}</strong>-->

                                <span class="ml-2"
                                      v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                      v-on:dblclick="onDoubleClick(entry.wordTermOrPhrase)">
                                    <strong>
                                        {{ entry.wordTermOrPhrase }}
                                    </strong>
                                </span>
                            </b-col>
                            <b-col v-if="showDescription" cols="8" style="right: 15px;"
                                   v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                   v-on:dblclick="onDoubleClick(entry.description)">
                                <span class="ml-1 text-wrap" style="white-space: pre-line !important;">
                                    {{ entry.description }}
                                </span>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col :cols="sortByWordOrTerm ? 11 : 10" v-if="showCards">
                        <div v-if="showCards" class="card-columns" :style="cardStyle">
                            <div class="card p-0"
                                 v-for="(entry,index) in filterGlossaryByPinned()"
                                 :key="index"
                                 :data-glossary-entry-id="entry.glossaryEntryId">
                                <span class="ml-2"
                                      v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                      v-on:dblclick="onDoubleClick(entry.wordTermOrPhrase)">
                                    <span>&nbsp;<i class="fas fa-map-pin"></i>&nbsp;&nbsp;</span>
                                    <strong>
                                        {{ entry.wordTermOrPhrase }}
                                    </strong>
                                </span>
                                <span v-if="showDescription && entry.description != null"
                                      v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                      v-on:dblclick="onDoubleClick(entry.description)"
                                      style="white-space: pre-line !important;">
                                    -&nbsp;{{ entry.description }}
                                </span>
                            </div>
                        </div>
                    </b-col>
                </b-row>

            </div>

            <div class="mt-2" style="grid-area: contentHead;">
                <b-row>
                    <b-col cols="12">
                        <div class="badge-info ml-0">
                            <strong class="ml-2">Glossary Entries ({{ glossaryItemCount() }})</strong>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div id="nav-scroller" class="mt-0 border" style="grid-area: contentBody; overflow: hidden; position: relative; height: 100%;">
                <!--Display by word or term-->
                <b-row v-if="sortByWordOrTerm" style="overflow: hidden; height: 100%;">
                    <b-col cols="1" id="letterNavbar" style="overflow-y: scroll; height: 100%; right: 15px;">
                        <b-list-group vertical class="card sticky-top">
                            <b-list-group-item v-for="(char,index) in headers.headerLetters" :key="index" :href="'#nav-' + char">{{ char }}</b-list-group-item>
                        </b-list-group>
                    </b-col>

                    <b-col cols="11" style="overflow-y: scroll; height: 100%; right: 15px">
                        <div v-for="(char,index) in headers.headerLetters" :key="index" :id="'nav-' + char">
                            <div v-if="!showCards">
                                <b-row v-for="(entry,index) in filterGlossaryByLetter(char)"
                                       :key="index"
                                       :class="entry.rowClass"
                                       :data-glossary-entry-id="entry.glossaryEntryId">
                                    <b-col cols="4" v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'">
                                        <!--<span v-bind:class="entry.confirmedDateTimeUTC == null ? 'text-danger' : 'text-success'"><i class="fas fa-check"></i></span>&nbsp;<strong>{{ entry.wordTermOrPhrase }}</strong>-->

                                        <span class="ml-2"
                                              v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                              v-on:dblclick="onDoubleClick(entry.wordTermOrPhrase)">
                                            <strong>
                                                {{ entry.wordTermOrPhrase }}
                                            </strong>
                                        </span>
                                    </b-col>
                                    <b-col v-if="showDescription" cols="8"
                                           v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                           v-on:dblclick="onDoubleClick(entry.description)">
                                        <span class="ml-1 text-wrap" style="white-space: pre-line !important;">
                                            {{ entry.description }}
                                        </span>
                                    </b-col>
                                </b-row>
                            </div>

                            <div v-if="showCards">
                                <b-row>
                                    <div :style="columnWidth"
                                         v-for="(entry,index) in filterGlossaryByLetter(char)"
                                         :key="index"
                                         class="card p-1"
                                         :data-glossary-entry-id="entry.glossaryEntryId">
                                        <div>
                                            <span class="ml-2"
                                                  v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                                  v-on:dblclick="onDoubleClick(entry.wordTermOrPhrase)">
                                                <strong>
                                                    {{ entry.wordTermOrPhrase }}
                                                </strong>
                                            </span>
                                            <span v-if="showDescription && entry.description != null"
                                                  v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                                  v-on:dblclick="onDoubleClick(entry.description)"
                                                  style="white-space: pre-line !important;">
                                                -&nbsp;{{ entry.description }}
                                            </span>
                                        </div>
                                    </div>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!--Display by category-->
                <b-row v-if="!sortByWordOrTerm" style="overflow: hidden; height: 100%;">
                    <b-col cols="2" id="letterNavbar" style="overflow-y: scroll; height: 100%; right: 15px">
                        <b-list-group vertical class="card sticky-top">
                            <b-list-group-item v-for="(category,index) in visibleCategories.glossaryEntryCategoryHeaderList" :key="index"
                                               :href="'#nav-' + category.glossaryEntryCategory.glossaryEntryCategoryId">
                                {{ category.glossaryEntryCategory.name }}
                                <b-list-group-item v-for="(char,index) in category.headerLetters" :key="index" :href="'#nav-' + category.glossaryEntryCategory.glossaryEntryCategoryId + '-' + char"
                                                   class="mt-1">{{ char }}</b-list-group-item>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>

                    <b-col cols="10" style="overflow-y: scroll; height: 100%; right: 15px">
                        <div v-for="(category,index) in visibleCategories.glossaryEntryCategoryHeaderList" :key="index" :id="'nav-' + category.glossaryEntryCategory.glossaryEntryCategoryId">
                            <div v-if="!showCards">
                                <b-row>
                                    <b-col cols="12">
                                        <div class="badge-info">
                                            <strong>{{ category.glossaryEntryCategory.name }}</strong>
                                        </div>
                                    </b-col>
                                </b-row>
                                <div v-for="(char,index) in category.headerLetters" :key="index" :id="'nav-' + category.glossaryEntryCategory.glossaryEntryCategoryId + '-' + char">
                                    <div v-for="(entry,index) in filterGlossaryByLetterAndCategory(char,category.glossaryEntryCategory.glossaryEntryCategoryId)"
                                         :key="index"
                                         :data-glossary-entry-id="entry.glossaryEntryId">
                                        <b-row>
                                            <b-col cols="4" v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'">
                                                <!--<span v-bind:class="entry.confirmedDateTimeUTC == null ? 'text-danger' : 'text-success'"><i class="fas fa-check"></i></span>&nbsp;<strong>{{ entry.wordTermOrPhrase }}</strong>-->

                                                <span class="ml-2"
                                                      v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                                      v-on:dblclick="onDoubleClick(entry.wordTermOrPhrase)">
                                                    <strong>
                                                        {{ entry.wordTermOrPhrase }}
                                                    </strong>
                                                </span>
                                            </b-col>
                                            <b-col v-if="showDescription" cols="8"
                                                   v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                                   v-on:dblclick="onDoubleClick(entry.description)">
                                                <span class="ml-1 text-wrap" style="white-space: pre-line !important;">
                                                    {{ entry.description }}
                                                </span>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </div>
                            </div>

                            <div v-if="showCards">
                                <b-row>
                                    <b-col cols="12">
                                        <div class="badge-info ml-0">
                                            <strong>{{ category.glossaryEntryCategory.name }}</strong>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row v-for="(char,index) in category.headerLetters" :key="index" :id="'nav-' + category.glossaryEntryCategory.glossaryEntryCategoryId + '-' + char"
                                       class="m-1">
                                    <div :style="columnWidth" v-for="(entry,index) in filterGlossaryByLetterAndCategory(char, category.glossaryEntryCategory.glossaryEntryCategoryId)"
                                         :key="index"
                                         class="card p-1"
                                         :data-glossary-entry-id="entry.glossaryEntryId">
                                        <div>
                                            <span class="ml-2"
                                                  v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                                  v-on:dblclick="onDoubleClick(entry.wordTermOrPhrase)">
                                                <strong>
                                                    {{ entry.wordTermOrPhrase }}
                                                </strong>
                                            </span>
                                            <span v-if="showDescription && entry.description != null"
                                                  v-bind:class="entry.disabledDateTimeUTC != null ? 'text-danger' : entry.lastUpdateDateTimeUTC != null ? 'text-primary' : 'text-dark'"
                                                  v-on:dblclick="onDoubleClick(entry.description)"
                                                  style="white-space: pre-line !important;">
                                                -&nbsp;{{ entry.description }}
                                            </span>
                                        </div>
                                    </div>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div> <!-- end glossary content div-->

        <ejs-contextmenu id="cmenu"
                         target="#nav-scroller, #sticky"
                         :items="contextMenuItems"
                         :beforeOpen="onBeforeOpen"
                         :select="menuItemSelected">
        </ejs-contextmenu>

        <b-modal size="lg"
                 centered
                 title="Glossary Entry"
                 ok-title="OK"
                 cancel-title="Close"
                 v-model="viewHistoryDialogShown">
            <b-form-row v-if="currentGlossaryEntry.courtMatterId != null">
                <b-form-group label="Court Matter" label-for="currentGlossaryEntry.courtMatterId" class="col-md-8">
                    <b-form-input v-model="currentGlossaryEntry.courtMatterName" disabled class="align-bottom col-md-11" />
                </b-form-group>
            </b-form-row>
            <b-form-row v-if="currentGlossaryEntry.interviewId != null">
                <b-form-group label="Interview" label-for="currentGlossaryEntry.interviewId" class="col-md-8">
                    <b-form-input v-model="currentGlossaryEntry.interviewName" disabled class="align-bottom col-md-11" />
                </b-form-group>
            </b-form-row>
            <b-form-row>
                <b-form-group label="Word Term or Phrase" label-for="currentGlossaryEntry.wordTermOrPhrase" class="col-md-6">
                    <b-form-input name="wordTermOrPhrase" v-model="currentGlossaryEntry.wordTermOrPhrase" disabled enabled="false" />
                </b-form-group>
                <b-form-group v-if="currentGlossaryEntry.glossaryEntryCategoryId != null" label="Category" label-for="currentGlossaryEntry.glossaryEntryCategoryId" class="col-md-6">
                    <b-form-input v-model="currentGlossaryEntry.categoryName" disabled class="align-bottom col-md-11" />
                </b-form-group>
            </b-form-row>
            <b-form-row>
                <b-form-group label="Description" label-for="currentGlossaryEntry.description" class="col-md-12">
                    <b-form-textarea name="description" v-model="currentGlossaryEntry.description" disabled rows="5" enabled="false" style="white-space: pre-line !important;" />
                </b-form-group>
            </b-form-row>

            <!--<b-form-row>
                <b-form-group v-if="currentGlossaryEntry.confirmedDateTimeUTC != null" label="Confirmed" label-for="currentGlossaryEntry.confirmedDateTimeUTC" class="col-md-4">
                    <b-form-input :value="currentGlossaryEntry.confirmedDateTimeUTC | formatDateTime('DD/MM/YYYY h:mmA')" readonly></b-form-input>
                </b-form-group>
                <b-form-group v-if="currentGlossaryEntry.confirmedDateTimeUTC != null" label="Confirmed By" label-for="currentGlossaryEntry.confirmedDateTimeUTC" class="col-md-4">
                    <b-form-input name="confirmed" v-model="currentGlossaryEntry.confirmedByDisplayName" disabled enabled="false" />
                </b-form-group>
            </b-form-row>-->

            <b-form-row>
                <entity-history-list name="entityHistory"
                                     entity-type-name="GlossaryEntry"
                                     :entity-id="currentGlossaryEntry.glossaryEntryId">
                </entity-history-list>
            </b-form-row>
        </b-modal>

        <validation-observer v-slot="vo" slim>
            <vue-keypress key-event="keydown" :key-code="83" :modifiers="['altKey']" :preventDefault="true" @success="createOrEditEntry('saveAndAdd')"></vue-keypress>
            <vue-keypress key-event="keydown" :key-code="67" :modifiers="['altKey']" :preventDefault="true" @success="createOrEditEntry('saveAndClose')"></vue-keypress>
            <b-modal size="lg"
                     centered
                     :title="createOrEditTitle"
                     v-model="createEntryDialogShown"
                     v-on:ok.prevent="vo.handleSubmit(createOrEditEntry)">
                <b-form-row>
                    <b-form-group label="Category" label-for="glossaryCategory" class="col-md-8">
                        <!--<b-form-select :options="allGlossaryCategoryOptions" v-model="currentGlossaryEntry.glossaryEntryCategoryId" class="align-bottom col-md-10 mr-1" />-->

                        <select2 name="glossaryCategory"
                                 v-if="canCreateGlossaryCategories"
                                 v-model="currentGlossaryEntry.glossaryEntryCategoryId"
                                 :options="allGlossaryCategoryOptions"
                                 tags
                                 :create-tag="createGlossaryCategory"
                                 in-b-modal
                                 allow-clear
                                 @select="glossaryCategorySelected">
                        </select2>

                        <select2 name="glossaryCategory"
                                 v-if="!canCreateGlossaryCategories"
                                 v-model="currentGlossaryEntry.glossaryEntryCategoryId"
                                 :options="allGlossaryCategoryOptions"
                                 in-b-modal
                                 allow-clear
                                 @select="glossaryCategorySelected">
                        </select2>

                        <!--<b-button v-on:click="clearCategoryIdSelect" class="btn btn-secondary btn-sm ml-2" variant="secondary"><i class="fas fa-times whiteiconcolor"></i></b-button>-->
                    </b-form-group>
                </b-form-row>
                <b-form-row>
                    <validation-provider ref="wordTermOrPhraseValidationProvider"
                                         rules="required"
                                         name="Word Term or Phrase"
                                         v-slot="vp"
                                         slim>
                        <b-form-group label="Word, Term or Phrase" label-for="currentGlossaryEntry.wordTermOrPhrase" class="col-md-6">
                            <b-form-input ref="wordTermOrPhrase" name="wordTermOrPhrase" v-model="currentGlossaryEntry.wordTermOrPhrase" autofocus />
                            <b-form-invalid-feedback :state="vp.errors[0] ? false : null">{{ vp.errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
                <b-form-row>
                    <b-form-group label="Description" label-for="currentGlossaryEntry.description" class="col-md-12">
                        <b-form-textarea name="description" v-model="currentGlossaryEntry.description" rows="5" />
                    </b-form-group>
                </b-form-row>

                <template #modal-footer>
                    <div class="w-100 mb-2 p-0">
                        <div class="float-right">
                            <b-button v-if="!currentGlossaryEntry.glossaryEntryId" v-on:click="createOrEditEntry('saveAndAdd')" variant="secondary" class="mr-1" data-toggle="tooltip" title="Alt + S"><u>S</u>ave and New</b-button>
                            <b-button v-on:click="createOrEditEntry('saveAndClose')" variant="success" class="mr-1" data-toggle="tooltip" title="Alt + C">Save and <u>C</u>lose</b-button>
                            <b-button v-on:click="closeAddEntry" variant="danger" class="mr-2" data-toggle="tooltip" title="Esc">Cancel</b-button>
                        </div>
                    </div>
                </template>
            </b-modal>
        </validation-observer>

        <validation-observer v-slot="vo" slim>
            <b-modal size="md"
                     centered
                     :title="copyGlossaryTitle"
                     ok-title="Copy"
                     cancel-title="Cancel"
                     v-model="copyEntryDialogShown"
                     v-on:ok.prevent="vo.handleSubmit(submitCopyGlossary)">
                <b-form-row v-if="courtMatterId">
                    <validation-provider rules="required" :name="$t('Vue.CourtMatterSelect.Label.Matter')" v-slot="vp" slim>
                        <b-form-group :label="$t('Vue.CourtMatterSelect.Label.Matter')"
                                      label-for="courtMatterSelect"
                                      class="col-md-10">
                            <b-input-group>
                                <select2 css-class="form-control"
                                         name="courtMatterSelect"
                                         :placeholder="placeholder"
                                         enable-ajax
                                         :min-search-chars="2"
                                         search-hint="Enter 2 or more characters to start searching. Start with a # to search by Epiq Reference only."
                                         v-model="copyGlossaryTargetValue"
                                         v-on:search="findMatters"
                                         in-b-modal></select2>
                                <b-form-invalid-feedback :state="vp.errors[0] ? false : null">{{ vp.errors[0] }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
                <b-form-row v-else>
                    <validation-provider rules="required" :name="$t('Vue.Shared.Label.Interview')" v-slot="vp" slim>
                        <b-form-group :label="$t('Vue.Shared.Label.Interview')"
                                      label-for="interviewSelect"
                                      class="col-md-10">
                            <b-input-group>
                                <select2 css-class="form-control"
                                         name="interviewSelect"
                                         :placeholder="placeholder"
                                         enable-ajax
                                         :min-search-chars="2"
                                         search-hint="Enter 2 or more characters to start searching. Start with a # to search by Epiq Reference only."
                                         v-model="copyGlossaryTargetValue"
                                         v-on:search="findInterviews"
                                         in-b-modal></select2>
                                <b-form-invalid-feedback :state="vp.errors[0] ? false : null">{{ vp.errors[0] }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </validation-provider>
                </b-form-row>
            </b-modal>
        </validation-observer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import VueKeypress from 'vue-keypress';
    import Visibility from 'visibilityjs';

    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    import { extend, localize } from 'vee-validate';
    import { required } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    localize('en', en);

    import { VBScrollspyPlugin } from 'bootstrap-vue'

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import UuidMixins from '../mixins/UuidMixins';
    import GridMixins from '../mixins/GridMixins';
    import Select2 from './Select2';

    import EntityHistoryList from './EntityHistoryList.vue';
    import DateTimeMixin from '../mixins/DateTimeMixin';

    Vue.use(BootstrapVue);
    Vue.component('vue-keypress', VueKeypress);
    Vue.component('select2', Select2);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    Vue.component('entity-history-list', EntityHistoryList);

    Vue.use(VBScrollspyPlugin)

    export default {
        name: 'ElectronicGlossary',
        mixins: [ErrorsMixin, UuidMixins, GridMixins, DateTimeMixin],
        props: {
            canCreateGlossaryEntries: {
                type: Boolean,
                default: false
            },
            canModifyGlossaryEntries: {
                type: Boolean,
                default: false
            },
            canDeleteGlossaryEntries: {
                type: Boolean,
                default: false
            },
            canCreateGlossaryCategories: {
                type: Boolean,
                default: false
            },
            courtMatterOrInterviewName: {
                type: String,
                default: null
            },
            courtMatterId: {
                type: String,
                default: null
            },
            interviewId: {
                type: String,
                default: null
            },
            initialGlossaryCategoryOptions: {
                type: Array,
                default: null
            },
            refreshIntervalInMilliseconds: {
                type: Number,
                default: 5000
            },
        },
        data: function () {
            return {
                allGlossaryCategoryOptions: this.initialGlossaryCategoryOptions,
                allGlossaryEntries: null,

                contextMenuItems: [
                    {
                        text: 'Copy Word Term or Phrase',
                        id: 'copy-word',
                    },
                    {
                        text: 'Copy Description',
                        id: 'copy-description',
                    },
                    {
                        separator: true
                    },
                    {
                        text: 'Edit Glossary Entry',
                        id: 'edit-entry',
                    },
                    {
                        text: 'Copy Glossary Entry To',
                        id: 'copy-entry',
                    },
                    {
                        separator: true
                    },
                    {
                        text: 'Delete Glossary Entry',
                        id: 'delete-entry',
                    },
                    {
                        id: 'xxx',
                        separator: true
                    },
                    {
                        text: 'Confirm Entry',
                        id: 'confirm-entry',
                    },
                    {
                        text: 'Unconfirm Entry',
                        id: 'unconfirm-entry',
                    },
                    {
                        id: 'xxx',
                        separator: true
                    },
                    {
                        id: 'xxx',
                        separator: true
                    },
                    {
                        text: 'Pin Entry',
                        id: 'pin-entry',
                    },
                    {
                        text: 'Unpin Entry',
                        id: 'unpin-entry',
                    },
                    {
                        id: 'xxx',
                        separator: true
                    },
                    {
                        text: 'View History',
                        id: 'view-history',
                    },
                ],

                headers: {
                    headerLetters: [],
                    glossaryEntryCategories: [],
                    glossaryEntryCategoryHeaderList: [],
                },
                searchTerm: null,
                categoryFilterName: null,
                categoryFilterId: null,
                sortByWordOrTerm: true,

                showErrors: false,
                currentErrors: null,

                showDeleted: false,
                showDescription: true,
                displayColumns: 4,
                showCards: true,

                viewHistoryDialogShown: false,
                createEntryDialogShown: false,
                createCategoryDialogShown: false,
                copyEntryDialogShown: false,

                currentGlossaryEntry: {
                    glossaryEntryId: null,
                    courtMatterId: null,
                    interviewId: null,
                    glossaryEntryCategoryId: null,
                    glossaryEntryCategoryName: null,
                    wordTermOrPhrase: null,
                    description: null,
                    confirmedByDisplayName: null,
                    currentErrors: []
                },

                currentGlossaryCategory: {
                    glossaryEntryCategoryId: null,
                    name: null,
                    currentErrors: []
                },

                createOrEditTitle: null,
                copyGlossaryTitle: null,
                copyEntireGlossary: false,
                entryCount: 0,

                selectedGlossaryEntryId: null,

                copyGlossaryTargetValue: null,

                glossaryEntryHistory: null,

                pinnedOpen: true,

                timer: null,
                reloadPending: false,
                lastUpdateDateTimeUTC: null,
            }
        },
        computed: {
            placeholder: function () {
                if (this.courtMatterId) return this.$t('Vue.Shared.Select2Placeholder.CourtMatter');
                return this.$t('Vue.Shared.Select2Placeholder.Interview');
            },
            cardStyle: function () {
                return "column-count:" + this.displayColumns;
            },
            columnWidth: function () {
                return "width:" + 100 / this.displayColumns + "%";
            },
            visibleCategories: function () {
                if (this.categoryFilterName == null) {
                    return this.headers;
                }
                else {
                    var retval = {
                        glossaryEntryCategoryHeaderList: [],
                    };

                    this.headers.glossaryEntryCategoryHeaderList.forEach(p => {
                        var category = p.glossaryEntryCategory;
                        if (category.glossaryEntryCategoryId == this.categoryFilterId) {
                            retval.glossaryEntryCategoryHeaderList.push(p);
                        }
                    });

                    return retval;
                }
            },
            pinnedCount: function () {
                if (this.allGlossaryEntries == null) { return 0; }

                var retval = [];
                var glossaryEntries = this.allGlossaryEntries;

                glossaryEntries.forEach(p => {
                    var pinned = p.pinned;
                    if (pinned) {
                        retval.push(p);
                    }
                });

                return retval.length;
            },
            pinnedHeight: function () {
                return "300px";
            },
        },
        methods: {
            onDoubleClick: function (args) {
                navigator.clipboard.writeText(args);

                this.$bvToast.toast('"' + args + '" copied to clipboard', {
                    title: 'Copy to Clipboard',
                    variant: 'success',
                    appendToast: true
                });
            },

            onBeforeOpen: function (args) {
                args.cancel = true;

                this.selectedGlossaryEntryId = null;

                var menuObj = document.getElementById("cmenu").ej2_instances[0];

                var targetRow = args.event.target;
                while (((targetRow.id != "nav-scroller") || (targetRow.id != "sticky")) && ((targetRow.className.indexOf("row") < 0) || (targetRow.className.indexOf("div") < 0))) {
                    targetRow = targetRow.parentElement;

                    if (targetRow && targetRow.dataset && targetRow.dataset.glossaryEntryId) {
                        this.selectedGlossaryEntryId = targetRow.dataset.glossaryEntryId;
                        break;
                    }
                }

                if (this.selectedGlossaryEntryId) {
                    var glossaryEntry = this.allGlossaryEntries.find(p => p.glossaryEntryId == this.selectedGlossaryEntryId);
                    if (glossaryEntry) {
                        if (glossaryEntry.description == null) {
                            menuObj.hideItems(['Copy Description']);
                        }
                        else {
                            menuObj.showItems(['Copy Description']);
                        }

                        if (glossaryEntry.disabledDateTimeUTC == null) {
                            menuObj.showItems(['Edit Glossary Entry']);
                            menuObj.showItems(['Delete Glossary Entry']);
                        }
                        else {
                            menuObj.hideItems(['Edit Glossary Entry']);
                            menuObj.hideItems(['Delete Glossary Entry']);
                        }

                        //if (glossaryEntry.confirmedDateTimeUTC) {
                        menuObj.hideItems(['Confirm Entry']);
                        //menuObj.showItems(['Unconfirm Entry']);
                        //}
                        //else {
                        //    menuObj.showItems(['Confirm Entry']);
                        menuObj.hideItems(['Unconfirm Entry']);
                        //}

                        if (glossaryEntry.pinned) {
                            menuObj.hideItems(['Pin Entry']);
                            menuObj.showItems(['Unpin Entry']);
                        }
                        else {
                            menuObj.showItems(['Pin Entry']);
                            menuObj.hideItems(['Unpin Entry']);
                        }

                        args.cancel = false;
                    }
                }
            },

            hidePinnedSection: function () {
                var pinnedSection = document.getElementById("sticky");
                pinnedSection.style.height = 0;
            },
            resetPinnedSectionHeight: function () {
                var pinnedSection = document.getElementById("sticky");
                pinnedSection.style.height = "auto";
            },

            menuItemSelected: function (args) {
                var glossaryEntry = this.allGlossaryEntries.find(p => p.glossaryEntryId == this.selectedGlossaryEntryId);

                if (glossaryEntry == null) { return; }

                if (args.item.id == 'copy-word') {
                    this.onDoubleClick(glossaryEntry.wordTermOrPhrase);
                }
                else if (args.item.id == 'copy-description') {
                    this.onDoubleClick(glossaryEntry.description);
                }
                else if (args.item.id == 'edit-entry') {
                    this.editEntry(glossaryEntry);
                }
                else if (args.item.id == 'copy-entry') {
                    this.copyGlossaryTitle = "Copy Glossary Entry To";
                    this.copyEntireGlossary = false;
                    this.currentErrors = null;
                    this.showErrors = false;
                    this.copyEntryDialogShown = true;
                }
                else if (args.item.id == 'delete-entry') {
                    this.$bvModal.msgBoxConfirm(
                        [
                            this.$createElement(
                                'div',
                                {
                                    domProps:
                                    {
                                        innerHTML: "<p>Are you sure you want to DELETE the glossary entry '" + glossaryEntry.wordTermOrPhrase + "'?</p>"
                                    }
                                }
                            )
                        ],
                        {
                            title: 'Delete Glossary Entry',
                            size: 'md',
                            okVariant: 'danger',
                            okTitle: 'Yes, DELETE Glossary Entry',
                            cancelTitle: 'No, Do Not Delete',
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                this.deleteEntry(glossaryEntry.glossaryEntryId);
                                this.refreshGlossary();
                            }
                        });
                }
                else if (args.item.id == 'view-history') {
                    this.viewHistory(glossaryEntry);
                }
                else if (args.item.id == 'confirm-entry') {
                    this.$bvModal.msgBoxConfirm(
                        [
                            this.$createElement(
                                'div',
                                {
                                    domProps:
                                    {
                                        innerHTML: "<p>Are you sure you want to CONFIRM the glossary entry '" + glossaryEntry.wordTermOrPhrase + "'?</p>"
                                    }
                                }
                            )
                        ],
                        {
                            title: 'Confirm Glossary Entry',
                            size: 'md',
                            okVariant: 'success',
                            okTitle: 'Yes, CONFIRM Glossary Entry',
                            cancelTitle: 'No, Do Not Confirm',
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                this.confirmEntry(glossaryEntry.glossaryEntryId);
                                this.refreshGlossary();
                            }
                        });
                }
                else if (args.item.id == 'unconfirm-entry') {
                    this.$bvModal.msgBoxConfirm(
                        [
                            this.$createElement(
                                'div',
                                {
                                    domProps:
                                    {
                                        innerHTML: "<p>Are you sure you want to UNCONFIRM the glossary entry '" + glossaryEntry.wordTermOrPhrase + "'?</p>"
                                    }
                                }
                            )
                        ],
                        {
                            title: 'Unconfirm Glossary Entry',
                            size: 'md',
                            okVariant: 'success',
                            okTitle: 'Yes, UNCONFIRM Glossary Entry',
                            cancelTitle: 'No, Do Not Unconfirm',
                            centered: true
                        })
                        .then(value => {
                            if (value) {
                                this.unconfirmEntry(glossaryEntry.glossaryEntryId);
                                this.refreshGlossary();
                            }
                        });
                }
                else if (args.item.id == 'pin-entry') {
                    this.pinEntry(glossaryEntry.glossaryEntryId);
                    this.refreshGlossary();
                }
                else if (args.item.id == 'unpin-entry') {
                    this.unpinEntry(glossaryEntry.glossaryEntryId);
                    this.refreshGlossary();
                }
            },

            createEntry: function () {
                this.createEntryDialogShown = true;
                this.createOrEditTitle = "Create Glossary Entry - " + this.courtMatterOrInterviewName;

                this.currentGlossaryEntry.glossaryEntryId = null;
                this.currentGlossaryEntry.courtMatterId = this.courtMatterId;
                this.currentGlossaryEntry.interviewId = this.interviewId;
                this.currentGlossaryEntry.glossaryEntryCategoryId = null;
                this.currentGlossaryEntry.wordTermOrPhrase = null;
                this.currentGlossaryEntry.description = null;
                this.currentGlossaryEntry.confirmedByUserAccount = null;
                this.currentGlossaryEntry.pinned = false;

                this.currentErrors = null;
                this.showErrors = false;
            },
            editEntry: function (glossaryEntry) {
                this.createEntryDialogShown = true;
                this.createOrEditTitle = "Edit Glossary Entry - " + this.courtMatterOrInterviewName;

                this.currentGlossaryEntry.glossaryEntryId = glossaryEntry.glossaryEntryId;
                this.currentGlossaryEntry.wordTermOrPhrase = glossaryEntry.wordTermOrPhrase;
                this.currentGlossaryEntry.description = glossaryEntry.description;
                this.currentGlossaryEntry.glossaryEntryCategoryId = glossaryEntry.glossaryEntryCategoryId;
                this.currentGlossaryEntry.pinned = glossaryEntry.pinned;

                this.currentErrors = null;
                this.showErrors = false;
            },
            glossaryCategorySelected: function (data) {
                this.currentGlossaryEntry.glossaryEntryCategoryName = (data && data.text) ? data.text : null;
            },
            createGlossaryCategory: function (name) {
                return {
                    id: this.newUuid(),
                    text: name
                }
            },
            createOrEditEntry: function (action) {
                if (!this.createEntryDialogShown) {
                    return;
                }

                var wordTermOrPhrase = this.currentGlossaryEntry.wordTermOrPhrase.trim();
                if (wordTermOrPhrase == null || wordTermOrPhrase == '') {
                    return;
                }

                var url = this.$urlHelper.getApiUrl("ElectronicGlossary");
                var data =
                {
                    glossaryEntryId: this.currentGlossaryEntry.glossaryEntryId,
                    courtMatterId: this.currentGlossaryEntry.courtMatterId,
                    interviewId: this.currentGlossaryEntry.interviewId,
                    glossaryEntryCategoryId: this.currentGlossaryEntry.glossaryEntryCategoryId,
                    glossaryEntryCategoryName: this.currentGlossaryEntry.glossaryEntryCategoryName,
                    wordTermOrPhrase: wordTermOrPhrase,
                    description: this.currentGlossaryEntry.description,
                    pinned: this.currentGlossaryEntry.pinned,
                };

                if (data.description != null) {
                    data.description = data.description.trim();
                }

                if (data.glossaryEntryCategoryName != null) {
                    data.glossaryEntryCategoryName = data.glossaryEntryCategoryName.trim();
                }

                if (!this.isUuidNullOrEmpty(this.currentGlossaryEntry.glossaryEntryId)) {
                    var originalGlossaryEntry = this.allGlossaryEntries.find(p => p.glossaryEntryId == data.glossaryEntryId);
                    var categoryChanged = originalGlossaryEntry.glossaryEntryCategoryId != data.glossaryEntryCategoryId;

                    if (originalGlossaryEntry.wordTermOrPhrase?.trim() == data.wordTermOrPhrase?.trim() &&
                        originalGlossaryEntry.description?.trim() == data.description?.trim() &&
                        categoryChanged == false
                    ) {
                        this.showErrorsToast(['There are no changes to save.'])
                        return;
                    }
                }

                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Glossary entry saved successfully', {
                            title: 'Glossary Entry Saved',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        if (action == 'saveAndClose') {
                            this.createEntryDialogShown = false;
                            this.refreshGlossary();
                        }
                        else if (action == 'saveAndAdd') {
                            this.refreshGlossary();
                            this.createEntry();
                            this.$refs.wordTermOrPhraseValidationProvider.reset();
                            this.$refs.wordTermOrPhrase.focus();
                        }
                    });
            },
            closeAddEntry: function () {
                this.createEntryDialogShown = false;
                this.refreshGlossary();
            },
            deleteEntry: function (glossaryEntryId) {
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary", glossaryEntryId);
                //console.log(url);
                var data =
                {

                };
                axios
                    .delete(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Glossary entry deleted successfully', {
                            title: 'Glossary Entry Cancelled',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.refreshGlossary();
                    });
            },
            confirmEntry: function (glossaryEntryId) {
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary/confirmGlossaryEntry", glossaryEntryId);
                //console.log(url);
                var data =
                {

                };
                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Glossary entry successfully confirmed', {
                            title: 'Glossary Entry Confirmed',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.refreshGlossary();
                    });
            },
            unconfirmEntry: function (glossaryEntryId) {
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary/unconfirmGlossaryEntry", glossaryEntryId);
                //console.log(url);
                var data =
                {

                };
                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Glossary entry successfully unconfirmed', {
                            title: 'Glossary Entry Unconfirmed',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.refreshGlossary();
                    });
            },
            pinEntry: function (glossaryEntryId) {
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary/pinGlossaryEntry", glossaryEntryId);
                //console.log(url);
                var data =
                {

                };
                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Glossary entry successfully pinned', {
                            title: 'Glossary Entry Pinned',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.refreshGlossary();
                    });
            },
            unpinEntry: function (glossaryEntryId) {
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary/unpinGlossaryEntry", glossaryEntryId);
                //console.log(url);
                var data =
                {

                };
                axios
                    .post(url, JSON.stringify(data), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(() => {
                        this.$bvToast.toast('Glossary entry successfully unpinned', {
                            title: 'Glossary Entry Unpinned',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.refreshGlossary();
                    });
            },
            viewHistory: function (glossaryEntry) {
                this.currentGlossaryEntry = glossaryEntry

                this.currentErrors = null;
                this.showErrors = false;
                this.viewHistoryDialogShown = true;
            },

            copyGlossaryBtn: function () {
                if (this.createEntryDialogShown) {
                    return;
                }

                this.copyGlossaryTitle = "Copy Glossary To";
                this.copyEntireGlossary = true;
                this.currentErrors = null;
                this.showErrors = false;
                this.copyEntryDialogShown = true;
            },
            submitCopyGlossary: function () {
                if (this.copyEntireGlossary) {
                    this.copyGlossary();
                }
                else {
                    this.copyEntry();
                }
            },
            copyEntry: function () {
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary", "copyGlossaryEntry", [this.selectedGlossaryEntryId, this.copyGlossaryTargetValue]);
                axios
                    .get(url)
                    .then(() => {
                        this.$bvToast.toast('Glossary entry copied successfully', {
                            title: 'Glossary Entry Copied',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.copyEntryDialogShown = false;
                    });
            },
            copyGlossary: function () {
                var courtMatterOrInterviewId = '';
                if (this.courtMatterId != null) {
                    courtMatterOrInterviewId = this.courtMatterId;
                }
                else {
                    courtMatterOrInterviewId = this.interviewId;
                }
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary", "copyGlossary", [courtMatterOrInterviewId, this.copyGlossaryTargetValue]);
                //console.log(url);
                axios
                    .get(url)
                    .then(() => {
                        this.$bvToast.toast('Glossary copied successfully', {
                            title: 'Glossary Copied',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    })
                    .finally(() => {
                        this.copyEntryDialogShown = false;
                    });
            },

            selectedCategoryColor: function (categoryId) {
                if (categoryId == this.categoryFilterId) {
                    return 'primary';
                }

                return 'secondary';
            },

            filterGlossaryByPinned: function () {
                if (this.allGlossaryEntries == null) { return null; }

                var retval = [];
                var glossaryEntries = this.allGlossaryEntries;

                glossaryEntries.forEach(p => {
                    var pinned = p.pinned;
                    if (pinned) {
                        retval.push(p);
                    }
                });

                return retval;
            },
            pinnedItemCount: function () {
                return this.filterGlossaryByPinned() ? this.filterGlossaryByPinned().length : 0;
            },
            glossaryItemCount: function () {
                var pinnedLength = this.filterGlossaryByPinned() ? this.filterGlossaryByPinned().length : 0;
                var allGlossaryEntries = this.allGlossaryEntries ? this.allGlossaryEntries.length : 0;
                var glossaryLength = allGlossaryEntries - pinnedLength;
                return glossaryLength;
            },
            filterGlossaryByLetter: function (letter) {
                if (this.allGlossaryEntries == null) { return null; }

                var retval = [];
                var glossaryEntries = this.allGlossaryEntries;

                glossaryEntries.forEach(p => {
                    var wordTermOrPhrase = p.wordTermOrPhrase;
                    var pinned = p.pinned;
                    if (wordTermOrPhrase?.toUpperCase().slice(0, 1) == letter.toUpperCase() && !pinned) {
                        retval.push(p);
                    }
                });

                return retval;
            },
            filterGlossaryByLetterAndCategory: function (letter, categoryId) {
                if (this.allGlossaryEntries == null) { return null; }

                var retval = [];
                var glossaryEntries = this.allGlossaryEntries;

                if (this.isUuidNullOrEmpty(categoryId)) {
                    glossaryEntries.forEach(p => {
                        var wordTermOrPhrase = p.wordTermOrPhrase;
                        var glossaryEntryCategoryId = p.glossaryEntryCategoryId;
                        var pinned = p.pinned;
                        if (wordTermOrPhrase?.toUpperCase().slice(0, 1) == letter.toUpperCase() && !pinned && glossaryEntryCategoryId == null) {
                            retval.push(p);
                        }
                    });
                }
                else {
                    glossaryEntries.forEach(p => {
                        var wordTermOrPhrase = p.wordTermOrPhrase;
                        var glossaryEntryCategoryId = p.glossaryEntryCategoryId;
                        var pinned = p.pinned;
                        if (wordTermOrPhrase?.toUpperCase().slice(0, 1) == letter.toUpperCase() && !pinned && glossaryEntryCategoryId == categoryId) {
                            retval.push(p);
                        }
                    });
                }

                return retval;
            },
            filterGlossaryByCategory: function (categoryId) {
                if (this.allGlossaryEntries == null) { return null; }

                var retval = [];
                var glossaryEntries = this.allGlossaryEntries;

                if (this.isUuidNullOrEmpty(categoryId)) {
                    glossaryEntries.forEach(p => {
                        var glossaryEntryCategoryId = p.glossaryEntryCategoryId;
                        var pinned = p.pinned;
                        if (!pinned && glossaryEntryCategoryId == null) {
                            retval.push(p);
                        }
                    });
                }
                else {
                    glossaryEntries.forEach(p => {
                        var glossaryEntryCategoryId = p.glossaryEntryCategoryId;
                        var pinned = p.pinned;
                        if (!pinned && glossaryEntryCategoryId == categoryId) {
                            retval.push(p);
                        }
                    });
                }

                return retval;
            },

            filterByCategoryNameAndId: function (categoryName, categoryId) {
                this.categoryFilterName = categoryName;
                this.categoryFilterId = categoryId;
                this.refreshGlossary();
            },

            toggleSortByWordOrTerm: function () {
                this.sortByWordOrTerm = true;
                this.refreshGlossary();
            },
            toggleSortByCategory: function () {
                this.sortByWordOrTerm = false;
                this.refreshGlossary();
            },

            toggleLines: function () {
                this.showCards = false;
                this.saveGlossaryLayout();
            },
            toggleCards: function () {
                this.showCards = true;
                this.saveGlossaryLayout();
            },
            toggleDeleted: function () {
                this.saveGlossaryLayout();
                this.refreshGlossary();
            },
            toggleDescription: function () {
                this.saveGlossaryLayout();
            },
            setColumns: function (cols) {
                this.displayColumns = cols;
                this.saveGlossaryLayout();
            },
            saveGlossaryLayout: function () {
                var currentOptions = {
                    showDeleted: this.showDeleted,
                    showDescription: this.showDescription,
                    displayColumns: this.displayColumns,
                    showCards: this.showCards,
                    sortByWordOrTerm: this.sortByWordOrTerm,
                }
                localStorage.setItem(this.addTopsInstallationAndVersionPrefix('glossaryLayout'), JSON.stringify(currentOptions));
            },

            refreshGlossary: function () {   
                if (this.timer != null) {
                    Visibility.stop(this.timer);
                    this.timer = null;
                }
                if (this.reloadPending) return;
                this.reloadPending = true;

                var promises = [];
                promises.push(this.loadCategories());
                promises.push(this.loadHeaders());
                promises.push(this.loadEntries());
                promises.push(this.saveGlossaryLayout());

                Promise
                    .all(promises)
                    .then(() => {
                        this.reloadPending = false;
                        // if ANY of the modals is open stop reloading, the v-on:hidden method in the modal resumes reloading by calling this.reload()
                        // first part are all the v-models of b-modals in this component ...
                        if (!this.viewHistoryDialogShown &&
                            !this.createEntryDialogShown &&
                            !this.createCategoryDialogShown &&
                            !this.copyEntryDialogShown) {
                            //console.log('reloading');

                            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.refreshGlossary);

                            if (this.viewHistoryDialogShown ||
                                this.createEntryDialogShown ||
                                this.createCategoryDialogShown ||
                                this.copyEntryDialogShown) {
                                //console.log('skip reloading');
                                return;
                            }

                            if (this.allGlossaryEntries && this.allGlossaryEntries.length > 0) {
                                if (!this.lastUpdateDateTimeUTC) {
                                    var maxDate = this.parseDateTime(new Date(this.allGlossaryEntries[0].effectiveLastUpdateDateTimeUTC), 'DD/MM/YYYY hh:mm:ss', true, true);

                                    this.allGlossaryEntries.forEach(entry => {
                                        var dateToCheck = this.parseDateTime(new Date(entry.effectiveLastUpdateDateTimeUTC), 'DD/MM/YYYY hh:mm:ss', true, true);

                                        if (dateToCheck > maxDate) {
                                            maxDate = dateToCheck;
                                        }
                                    });
                                    this.lastUpdateDateTimeUTC = maxDate;
                                }
                                                                
                                this.allGlossaryEntries.forEach(entry => {
                                    var dateToCheck = this.parseDateTime(new Date(entry.effectiveLastUpdateDateTimeUTC), 'DD/MM/YYYY hh:mm:ss', true, true);

                                    if (dateToCheck > this.lastUpdateDateTimeUTC) {
                                        this.lastUpdateDateTimeUTC = dateToCheck;
                                        this.$bvToast.toast('A glossary entry has been updated.', {
                                            title: 'Change Detected',
                                            variant: 'success',
                                            appendToast: true
                                        });
                                    }
                                });
                            }
                        } else {
                            //console.log('reloading PAUSED');
                        }
                    })
            },
            searchGlossary: function () {
                if (this.searchTerm.length < 2) { return; }
                this.refreshGlossary();
            },
            clearSearch: function () {
                this.searchTerm = null;
                this.refreshGlossary();
            },

            printGlossary: function () {
                var url = this.$urlHelper.getApiUrl("ElectronicGlossary", "printGlossary");

                var filter = {};
                if (this.courtMatterId != null) {
                    filter.courtMatterId = this.courtMatterId;
                }
                else if (this.interviewId != null) {
                    filter.interviewId = this.interviewId;
                }

                if (this.categoryFilterName == null && this.isUuidNullOrEmpty(this.categoryFilterId)) { //show all
                    filter.glossaryEntryCategoryId = null;
                    filter.showOnlyUncategorised = false;
                }
                else {
                    if (this.categoryFilterName == "Uncategorised") { //show uncategorised
                        filter.glossaryEntryCategoryId = null;
                        filter.showOnlyUncategorised = true;
                    }
                    else {
                        filter.glossaryEntryCategoryId = this.categoryFilterId;
                        filter.showOnlyUncategorised = false;
                    }
                }

                if (this.searchTerm != null) {
                    filter.searchTerm = this.searchTerm;
                }

                filter.includeDeleted = this.showDeleted;
                filter.includeDescriptions = this.showDescription;

                axios
                    .post(url, JSON.stringify(filter), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var glossaryFileId = response.data;
                        console.log(glossaryFileId);

                        if (glossaryFileId != null) {
                            var url = this.$urlHelper.getFileDownloadUrl(glossaryFileId);
                            console.log(url);
                            window.open(url);
                        }
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    });
            },

            loadEntries: function () {
                var url = this.$urlHelper.getApiUrl('ElectronicGlossary', 'list');

                var filter = {};
                if (this.courtMatterId != null) {
                    filter.courtMatterId = this.courtMatterId;
                }
                else if (this.interviewId != null) {
                    filter.interviewId = this.interviewId;
                }

                if (this.categoryFilterName == null && this.isUuidNullOrEmpty(this.categoryFilterId)) { //show all
                    filter.glossaryEntryCategoryId = null;
                    filter.showOnlyUncategorised = false;
                }
                else {
                    if (this.categoryFilterName == "Uncategorised") { //show uncategorised
                        filter.glossaryEntryCategoryId = null;
                        filter.showOnlyUncategorised = true;
                    }
                    else {
                        filter.glossaryEntryCategoryId = this.categoryFilterId;
                        filter.showOnlyUncategorised = false;
                    }
                }

                if (this.searchTerm != null) {
                    filter.searchTerm = this.searchTerm;
                }

                filter.includeDeleted = this.showDeleted;
                filter.includeDescriptions = this.showDescription;

                axios
                    .post(url, JSON.stringify(filter), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        var index = 0;
                        this.allGlossaryEntries = response.data.map(e => {
                            index += 1;
                            e.rowClass = (index % 2) ? "odd" : "even";
                            return e;
                        });
                        this.entryCount = 0;
                        this.entryCount = this.allGlossaryEntries?.length;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    });
            },
            loadHeaders: function () {
                var url = this.$urlHelper.getApiUrl('ElectronicGlossary', this.sortByWordOrTerm ? 'headers' : 'categoryheaders');

                var filter = {};
                if (this.courtMatterId != null) {
                    filter.courtMatterId = this.courtMatterId;
                }
                else if (this.interviewId != null) {
                    filter.interviewId = this.interviewId;
                }

                if (this.categoryFilterName == null && this.isUuidNullOrEmpty(this.categoryFilterId)) { //show all
                    filter.glossaryEntryCategoryId = null;
                    filter.showOnlyUncategorised = false;
                }
                else {
                    if (this.categoryFilterName == "Uncategorised") { //show uncategorised
                        filter.glossaryEntryCategoryId = null;
                        filter.showOnlyUncategorised = true;
                    }
                    else {
                        filter.glossaryEntryCategoryId = this.categoryFilterId;
                        filter.showOnlyUncategorised = false;
                    }
                }

                if (this.searchTerm != null) {
                    filter.searchTerm = this.searchTerm;
                }

                filter.includeDeleted = this.showDeleted;

                axios
                    .post(url, JSON.stringify(filter), {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        this.headers = response.data;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    });
            },
            loadCategories: function () {
                if (this.viewHistoryDialogShown ||
                    this.createEntryDialogShown ||
                    this.createCategoryDialogShown ||
                    this.copyEntryDialogShown) {
                    console.log('skip loadCategories');
                    return;
                }

                var url = this.$urlHelper.getApiUrl('ElectronicGlossaryCategory', 'selectlist');
                //console.log(url);

                axios
                    .get(url, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                    .then(response => {
                        this.allGlossaryCategoryOptions = response.data;
                    })
                    .catch(ex => {
                        var errors = this.handleAxiosException(ex);
                        this.showErrorsToast(errors);
                    });
            },
            findMatters: function (params, success, failure) {
                var filter = {
                    searchTerm: ''
                };
                if (typeof (params.data.term) != "undefined")
                    filter.searchTerm = params.data.term;
                var url = this.$urlHelper.getApiUrl('courtmatter', null, ['find']);

                this.lastSearchTerm = params.data.term;
                axios
                    .post(url, JSON.stringify(filter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(function (response) {
                        var mappedData = response.data;
                        if (mappedData != null) {
                            mappedData = $.map(mappedData, function (obj) {
                                obj.id = obj.courtMatterId;
                                obj.text = obj.displayName;
                                return obj;
                            });
                        }
                        success({ results: mappedData });
                    })
                    .catch(function (error) {
                        failure(error);
                    });
            },
            findInterviews: function (params, success, failure) {
                var filter = {
                    searchTerm: ''
                };
                if (typeof (params.data.term) != "undefined")
                    filter.searchTerm = params.data.term;
                var url = this.$urlHelper.getApiUrl('interview', null, ['find']);

                this.lastSearchTerm = params.data.term;
                axios
                    .post(url, JSON.stringify(filter),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(function (response) {
                        var mappedData = response.data;
                        if (mappedData != null) {
                            mappedData = $.map(mappedData, function (obj) {
                                obj.id = obj.interviewId;
                                obj.text = obj.displayName;
                                return obj;
                            });
                        }
                        success({ results: mappedData });
                    })
                    .catch(function (error) {
                        failure(error);
                    });
            },
            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.searchControls)) {
                    this.searchGlossary();
                }
            }
        },
        mounted: function () {
            var currentOptionsString = localStorage.getItem(this.addTopsInstallationAndVersionPrefix('glossaryLayout'));
            if (currentOptionsString) {
                var currentOptions = JSON.parse(currentOptionsString);
                this.showDeleted = currentOptions.showDeleted;
                this.showDescription = currentOptions.showDescription;
                this.displayColumns = currentOptions.displayColumns;
                this.showCards = currentOptions.showCards;
                this.sortByWordOrTerm = currentOptions.sortByWordOrTerm;
            } else {
                this.showDeleted = false;
                this.showDescription = true;
                this.displayColumns = 4;
                this.showCards = true;
                this.sortByWordOrTerm = true;
            }

            this.refreshGlossary();
        },
        beforeDestroy: function () {
            if (this.timer != null) Visibility.stop(this.timer);
        }
    }
</script>

<style scoped>

    .glossary-grid-container {
        display: grid;
        gap: 0;
        height: 100%;
        overflow: hidden;
        grid-template:
            [row1-start] "pinnedHead" min-content [row1-end]
            [row2-start] "pinnedBody" min-content [row2-end]
            [row3-start] "contentHead" min-content [row3-end]
            [row4-start] "contentBody" 1fr [row4-end];
    }

    #sticky {
        grid-area: pinnedBody;
        position: relative;
        height: auto;
        resize: vertical;
        overflow: hidden scroll;
        max-height: 300px;
    }


    #nav-scroller .row.even {
        background-color: lightgray;
    }

    @media print {
        #toolbar, #letterNavbar, #categoryNavbar {
            display: none;
        }

        div#nav-scroller, #sticky {
            border: none !important;
            overflow: visible !important;
        }

            #nav-scroller, #sticky .row {
                background-color: white !important;
                break-inside: avoid;
            }
    }

    @media screen {
        #printHeader {
            display: none;
        }
    }
</style>
